module.exports = __webpack_public_path__ + "components/AuthorizationModal/deny-2d2d82dacced137c10c223da1fce91ad.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/AuthorizationModal/deny.svg
// module id = 367
// module chunks = 0 1